import {
  CloseCircleOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';

import { CASH_STATUS_CONFIG } from 'components/tag/CashStatusConfig';
import { CLOSE_STATUS_CONFIG } from 'components/tag/CloseStatusConfig';
import {
  Green,
  Blue,
  Red,
  Orange,
  Purple,
  Default,
} from 'components/tag/StatusColorConfig';

import { StatusConfig } from 'types/tag/StatusConfigType';
import { StatusType } from 'types/tag/StatusType';

export const STATUS_CONFIG: Partial<Record<StatusType, StatusConfig>> = {
  connected: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Connected',
  },
  not_connected: {
    ...Red,
    icon: <CloseCircleOutlined />,
    title: 'Not Connected',
  },
  processing: {
    ...Blue,
    icon: <SyncOutlined spin className="animation-spin" />,
    title: 'Processing',
  },
  failed: {
    ...Red,
    icon: <CloseCircleOutlined />,
    title: 'Failed',
  },
  current: {
    ...Blue,
    icon: <SyncOutlined spin className="animation-spin" />,
    title: 'Current',
  },
  in_review: {
    ...Orange,
    icon: <ClockCircleOutlined />,
    title: 'In Review',
  },
  needs_review: {
    ...Orange,
    icon: <InfoCircleOutlined />,
    title: 'Needs Review',
  },
  overdue: {
    ...Red,
    icon: <CloseCircleOutlined />,
    title: 'Overdue',
  },
  pending: {
    ...Blue,
    icon: <SyncOutlined spin className="animation-spin" />,
    title: 'Pending',
  },
  signed_off: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Signed-off',
  },
  completed: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Completed',
  },
  open: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Open',
  },
  approved: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Approved',
  },
  paid: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Paid',
  },
  voided: {
    ...Red,
    icon: <MinusCircleOutlined />,
    title: 'Voided',
  },
  categorized: {
    ...Blue,
    title: 'Categorized',
  },
  matched: {
    ...Purple,
    title: 'Matched',
  },
  reconciled: {
    ...Orange,
    title: 'Reconciled',
  },
  yes: {
    ...Green,
    title: 'Yes',
  },
  no: {
    ...Red,
    title: 'No',
  },
  inconclusive: {
    ...Orange,
    title: 'Inconclusive',
  },
  in_progress: {
    ...Blue,
    title: 'In-Progress',
  },
  all: {
    ...Default,
    title: 'All',
  },
  not_completed: {
    ...Orange,
    title: 'Not Completed',
  },
  // --- Used by Checklist ---
  ...CLOSE_STATUS_CONFIG,

  // --- Used by Cash ---
  ...CASH_STATUS_CONFIG,
};
